import workflow1 from "../../Assets/AIOnDemand/top-workflow1.png";
import workflow2 from "../../Assets/AIOnDemand/top-workflow2.png";
import workflow3 from "../../Assets/AIOnDemand/top-workflow3.png";
const TopWorkflows = () => {
    const workflows = [
        {
            image: workflow1,
        },
        {
            image: workflow2,
        },
        {
            image: workflow3,
        },
        {
            image: workflow1,
        },
        {
            image: workflow2,
        },
        {
            image: workflow3,
        },
    ]
    return (
        <section className=" flex flex-col py-16 gap-10">
            <h1 className="text-3xl flex flex-row items-center justify-center gap-4 md:text-5xl lg:text-7xl text-black font-semibold text-center">
                Top Workflows
            </h1>
            <div className="flex flex-row overflow-x-scroll w-full noScrollBar">
                {
                    workflows.map((workflow, index) => (
                        <div key={index} className="h-full pointer-events-none">
                            <img src={workflow.image} alt={`Workflow ${index + 1}`} className="object-contain  h-full w-80 lg:w-[500px] !max-w-none " />
                        </div>
                    ))
                }

            </div>
        </section>
    );
}

export default TopWorkflows;